import { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

/**
 * Wraps a route so it redirects to /login if the user is not authenticated.
 * Pass adminOnly={true} to also require isAdmin.
 */
export default function ProtectedRoute({ children, adminOnly = false }) {
  const { registeredUser } = useContext(AuthContext);

  if (!registeredUser) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && !registeredUser.isAdmin) {
    return <Navigate to="/trader-dashboard" replace />;
  }

  return children;
}
